export enum TextFontWeight {
  Bold = 'bold',
  Normal = 'normal'
}
